import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.33353 4.33308C4.33353 2.30803 5.97515 0.666412 8.00019 0.666412C10.0253 0.666412 11.6669 2.30803 11.6669 4.33308V5.99975C11.6669 6.36793 11.3684 6.66641 11.0002 6.66641C10.632 6.66641 10.3335 6.36793 10.3335 5.99975V4.33308C10.3335 3.04441 9.28886 1.99975 8.00019 1.99975C6.71153 1.99975 5.66686 3.04441 5.66686 4.33308V5.99975C5.66686 6.36793 5.36838 6.66641 5.0002 6.66641C4.63201 6.66641 4.33353 6.36793 4.33353 5.99975V4.33308Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.00033 5.50001C2.98774 5.50001 2.1669 6.32092 2.16699 7.33354L2.16755 13.3335C2.16764 14.3459 2.98843 15.1667 4.00088 15.1667H12.0002C13.0127 15.1667 13.8335 14.3459 13.8335 13.3333V7.33334C13.8335 6.32082 13.0127 5.50001 12.0002 5.50001H4.00033ZM8.66699 9.66667C8.66699 9.29847 8.36853 9.00001 8.00033 9.00001C7.63213 9.00001 7.33366 9.29847 7.33366 9.66667V11C7.33366 11.3682 7.63213 11.6667 8.00033 11.6667C8.36853 11.6667 8.66699 11.3682 8.66699 11V9.66667Z",
		fill: "currentColor"
	})]
});
export default SvgLock;
